import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Paper,
  Tooltip,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Fragment, useRef } from "react";
import { GiCheckMark } from "react-icons/gi";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as mpFace from "@mediapipe/face_detection";
import { Camera } from "@mediapipe/camera_utils";

import { useAxios, useComponent } from "../../hooks";
import pages from "../../constants/pages";
import { Loader, LoadingButton } from "./../../components";
import { IoIosInformationCircleOutline } from "react-icons/io";

import Error from "../Error/Error";
import Instruction from "./Instruction";
import FaceVerification from "./assests/FaceVerification.svg";
import CameraStartPopUp from "./CameraStartPopUp";
import UserStatus from "./UserStatus";

import CloseIcon from "@mui/icons-material/Close";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import WifiIcon from "@mui/icons-material/Wifi";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";

import { Card, CardContent } from "@mui/material";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";
import { useDispatch, useSelector } from "react-redux";
import UserStatusPopup from "./UserStatusPopup";
import { setIsDocVerifiedStatus } from "../../redux/slices/memberSlice";

const primaryColor = "#007aff";

const OuterBox2 = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  background: #ffffff;
`;

const OuterPaper = styled(Paper)`
  width: 100%;
  padding: 0px 20px 20px;
  min-height: 20vh;
`;

const OuterPaper2 = styled(Paper)`
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  align-content: center;
  border-radius: 15px;
  position: relative;
`;

// const OuterBox2 = styled(Box)`
//   display: flex;
//   flex-direction: row;
//   justify-content: center;
//   align-items: center;
//   width: [100%, 100%, 100%, 800px];
//   // margin: 10% 0;
//   // padding: 0px 17px;
//   box-sizing: border-box;
//   height: 100%;
//   background: #ffffff;
// `;

// const OuterPaper = styled(Paper)`
//   width: [100%];
//   padding: 0px 20px 20px;
//   min-height: 20vh;
// `;

// const OuterPaper2 = styled(Paper)`
//   width: 100%;
//   // padding: 0px 20px 20px;
//   height: 100%;
//   background: rgba(255, 255, 255, 0.5);
//   align-content: center;
//   border-radius: 15px;
//   position: relative;
// `;

export default function UploadDocument() {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [mimeType, setMimeType] = useState("video/webm;codecs=vp8,opus");
  const axiosDigipass = useAxios({ baseURL: "digipass" });
  const { visitorData } = useSelector((state) => state.memberDetails);
  const location = useLocation();
  const { loader } = useComponent();
  const { visitor_id, id } = location.state || {};

  const queryParams = new URLSearchParams(location.search);
  const bookingId = queryParams.get("booking_id");
  const visitorId = queryParams.get("visitor_id");
  const popup = queryParams.get("popup");
  const doc_face = queryParams.get("doc_face");
  const entityId = queryParams.get("entity_id");
  const userTypeId = queryParams.get("user_type_id");
  const autoConsent = queryParams.get("auto_consent");
  const fromPreview = queryParams.get("from_preview");
  const indepentent = queryParams.get("indepentent");
  const liveness = queryParams.get("liveness");

  const [error, setError] = useState("");
  const [visitor_ID, setvisitor_ID] = useState("");
  const [open, setOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [cameraStartPopUp, setCameraStartPopUp] = useState(false);
  const [eventDetail, setEventDetail] = useState({});
  const [entityDetails, setEntityDetails] = useState({});
  const [consentAccepted, setConsentAccepted] = useState(
    !(autoConsent == "true")
  );

  const [disableButton, setDisableButton] = useState(false);

  const [loading, setLoading] = useState();

  useEffect(() => {
    if (entityId) {
      sessionStorage.setItem("eventID", entityId);

      axiosDigipass({
        url: "admin/events/event-details?event_id=" + entityId,
        method: "GET",
        customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
      }).then((response) => {
        if (response.status) {
          response?.data?.button_color &&
            sessionStorage.setItem("buttonColor", response.data.button_color);
          response?.data?.background_color &&
            sessionStorage.setItem(
              "buttonBackground",
              response.data.background_color
            );
          setEventDetail(response.data);
        }
      });
    }

    if (window.navigator.userAgent.indexOf("Windows") !== -1) {
      setMimeType("video/webm;codecs=vp8,opus");
    } else if (window.navigator.userAgent.indexOf("Mac OS") !== -1) {
      setMimeType("video/mp4");
    } else if (window.navigator.userAgent.indexOf("Linux") !== -1) {
      setMimeType("video/webm;codecs=vp8,opus");
    } else {
      setMimeType("video/webm;codecs=vp8,opus");
    }

    if (Boolean(bookingId)) {
      // axiosDigipass({
      //   url: "event/verify/booking-status/",
      //   method: "POST",
      //   data: { booking_id: bookingId },
      //   disableRedirect: true,
      // }).then((response) => {
      //   if (response?.status) {
      //     !response.data.is_valid && setError(response.message.displayMessage);
      //   } else {
      //     setError(response?.displayMessage);
      //     setErrorOpen(true);
      //   }
      // });
    }
  }, []);

  const [startRecording, setStartRecording] = useState(false);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const canvasSendRef = useRef(null);
  const [stream, setStream] = useState(null);

  const [userStatus, setUserStatus] = useState(false);
  const [userData, setUserData] = useState({});
  const [UserStatusPop, setUserStatusPopup] = useState(false);
  const [guideMessage, setGuideMessage] = useState("");

  const localStorageData = { ...localStorage };

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return item.includes(visitorId);
  });

  const [buttonMargin, setButtonMargin] = useState("5vh");

  useEffect(() => {
    const handleResize = () => {
      const height = window.innerHeight;
      if (height < 600) {
        setButtonMargin("2vh");
      } else if (height < 900) {
        setButtonMargin("6vh");
      } else {
        setButtonMargin("9vh");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (entityId != -1) {
      loader.start();
      let url = "admin/profile/get-visitor-booking-status";

      let method = "POST";

      let data = {
        visitor_id: visitorId,
        entity_id: entityId,
        user_type_id: userTypeId,
        booking_id: bookingId,
        face_data: getVisitorFaceData(visitorId),
      };

      axios({
        url: url,
        disableRedirect: true,
        method: method,
        data: data,
        disableError: true,
      }).then((response) => {
        if (response.status) {
          if (response.data[0]?.journey_status?.user_status !== "Verify") {
            if (userTypeId == 1) {
              navigate(
                `${pages.EventSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`
              );
            } else if (
              userTypeId == 3 ||
              userTypeId == 4 ||
              userTypeId == 6 ||
              userTypeId == 8
            ) {
              navigate(
                `${pages.CampusSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`
              );
            } else if (userTypeId == 2) {
              navigate(
                `${
                  indepentent
                    ? pages.IndependentAppointmentSummary.route
                    : pages.AppointmentSummary.route
                }?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`
              );
            } else if (userTypeId == 5) {
              navigate(
                `${pages.HotelSummary.path}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`
              );
            }
          }
        }
        loader.apiComplete();
      });
    }
  }, [axios]);

  useEffect(() => {
    if (!videoRef.current) return;

    startMediapipe();
  }, [videoRef.current]);

  const startMediapipe = async () => {
    const faceMesh = new mpFace.FaceDetection({
      locateFile: (file) =>
        `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
    });

    faceMesh.setOptions({
      model: "short",
      minDetectionConfidence: 0.7,
    });

    faceMesh.onResults(onResults);

    // Wait for WASM and model to load
    await faceMesh.initialize();

    const camera = new Camera(videoRef.current, {
      onFrame: async () => {
        await faceMesh.send({ image: videoRef.current });
      },
      width: 1280,
      height: 720,
    });

    camera.start();
  };

  const onResults = (results) => {
    const canvas = canvasRef?.current;
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas?.width, canvas?.height);

    if (!results.detections || results.detections.length === 0) return;

    const detection = results.detections[0];
    const box = detection.boundingBox;

    const x = box.xCenter * canvas?.width - (box?.width * canvas?.width) / 2;
    const y = box.yCenter * canvas?.height - (box?.height * canvas?.height) / 2;

    const w = box.width * canvas?.width;
    const h = box.height * canvas?.height;

    // Draw rectangle (optional, for debugging)
    ctx.lineWidth = 3;
    ctx.strokeStyle = "transparent";
    ctx.strokeRect(x, y, w, h);

    // Draw ellipse guide same as SVG

    const radiusX = (canvas?.width * 110) / 450; // scale from SVG rx to canvas width
    const radiusY = (canvas?.height * 170) / 350; // scale from SVG ry to canvas height

    // Center
    const centerX = canvas?.width / 2;
    const centerY = canvas?.height * 0.4; // match SVG Y position

    // Scale rx/ry from SVG to canvas
    const rx = (canvas?.width * 110) / 390; // maxWidth of SVG = 390
    const ry = (canvas?.height * 95) / 350; // SVG ry = 170, viewBox height = 350

    ctx.beginPath();
    ctx.ellipse(centerX, centerY, rx, ry, 0, 0, 2 * Math.PI);
    ctx.lineWidth = 15;
    ctx.strokeStyle = disableButton ? "transparent" : "transparent";
    ctx.setLineDash([7.5, 7.5]);
    ctx.stroke();
    ctx.setLineDash([]);

    // Alignment check
    const toleranceX = radiusX / canvas?.width; // scale tolerance to ellipse width
    const toleranceY = radiusY / canvas?.height; // scale tolerance to ellipse height

    const isCentered =
      Math.abs(box.xCenter - 0.5) < toleranceX &&
      Math.abs(box.yCenter - 0.485) < toleranceY;

    // Depth / proximity check
    const tooCloseThreshold = 0.522;

    // Compute face top/bottom in normalized coordinates
    const faceTop = box.yCenter - box.height / 1.5; // 0 to 1
    const faceBottom = box.yCenter + box.height / 2; // 0 to 1

    const ellipseTop = centerY / canvas.height - ry / canvas.height;
    const ellipseBottom = centerY / canvas.height + ry / canvas.height;

    // Top-boundary check: forehead must not go above ellipse
    const isTooHigh = faceTop < ellipseTop;

    // Bottom-boundary check: lips/chin must not go below ellipse
    const isTooLow = faceBottom > ellipseBottom;

    if (isTooHigh) {
      console.log("isTooHigh ");

      setGuideMessage("Face not aligned correctly!");
      setDisableButton(true);
    } else if (isTooLow) {
      console.log(" isTooLow");

      setGuideMessage("Face not aligned correctly!");
      setDisableButton(true);
    } else if (box.width > tooCloseThreshold) {
      console.log("You're too close to the camera!");

      setGuideMessage("You're too close to the camera!");
      setDisableButton(true);
    } else if (!isCentered) {
      console.log("Face not aligned correctly!");

      setGuideMessage("Face not aligned correctly!");
      setDisableButton(true);
    } else {
      console.log("Face aligned and correct depth!");

      setGuideMessage("Face aligned and correct depth!");
      setDisableButton(false);
    }
  };

  useEffect(() => {
    if (entityId != -1) {
      axiosDigipass({
        url: "/admin/business/entity_details?entity_id=" + entityId,
        disableRedirect: true,
        disableError: true,
      }).then((response) => {
        if (response.status) {
          setEntityDetails(response.data);
        }
      });
    }
  }, []);

  useEffect(() => {
    // if (processID) {
    //   axios({
    //     url: `notification/notification/bulk-process-requests?process_id=${processID}&entity_id=${campusId}`,
    //   }).then((response) => {
    //     if (response.status) {
    //       setvisitor_ID(response?.data[0]?.visitor_id);
    //     }
    //   });
    // }
  }, []);

  useEffect(() => {
    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });

    if (popup && faceData.length > 0) {
      window.close();
    }
  }, []);

  useEffect(() => {
    // if (digiLockerID) {
    //   axios({
    //     url: "event/govt-api/get-user-document",
    //     method: "POST",
    //     data: {
    //       document_type: "aadhar",
    //       request_id: digiLockerID,
    //     },
    //   }).then((response) => {
    //     if (response.status) {
    //       const name = response.data.aadhaar.name;
    //       const nameParts = name.split(" ");
    //       const first_name = nameParts[0];
    //       let last_name = nameParts.slice(1).join(" ");
    //       if (last_name.trim() === "") {
    //         last_name = first_name;
    //       }
    //       let payload = {
    //         doc_type: 1,
    //         booking_type: "event",
    //         aadharNo: response.data.aadhaar.maskedNumber,
    //         visitor_id: visitorId,
    //         first_name: first_name,
    //         last_name: last_name,
    //         gender: response.data.aadhaar.gender,
    //         dob: response.data.aadhaar.dateOfBirth,
    //         address: response.data.aadhaar.address,
    //         doc_face_image: response.data.aadhaar.photo,
    //       };
    //       payload.is_verified = 1;
    //       const payloadString = JSON.stringify(payload);
    //       localStorage.setItem("userPayload", payloadString);
    //     }
    //   });
    // }
  }, []);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {},
        audio: false,
      });
      setStream(stream);

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }

      const [track] = stream.getVideoTracks();
      const capabilities = track.getCapabilities();

      if (capabilities.zoom) {
        const settings = {
          advanced: [{ zoom: 1 }],
        };
        await track.applyConstraints(settings);
      }
    } catch (error) {
      if (error.name === "NotReadableError") {
        console.log(
          "NotReadableError: The camera might be in use or not available"
        );
        alert(
          "Unable to access the camera. Please ensure it's not in use by another application and refresh the page."
        );
        window.location.reload();
      } else if (error.name === "OverconstrainedError") {
        console.log(
          "OverconstrainedError: The constraints don't match any installed camera"
        );
        alert("No suitable camera found. Please check your camera settings.");
      } else {
        alert(`Error accessing camera: ${error.message}`);
      }
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null); // or streamRef.current = null;
    }
  };

  const takePhoto = async () => {
    setLoading(true);

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const canvasSend = canvasSendRef.current;

    // if (
    //   (canvas.width >= 150 || canvas.width <= 300) &&
    //   (canvas.height >= 600 || canvas.height <= 1200)
    // ) {
    if (video && canvas) {
      const context = canvas.getContext("2d");
      const contextSend = canvasSend.getContext("2d");

      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      const captureSize = 350;
      const sourceX = (videoWidth - captureSize) / 2;
      const sourceY = (videoHeight - captureSize) / 2;

      canvas.width = videoWidth;
      canvas.height = videoHeight;

      canvasSend.width = videoWidth;
      canvasSend.height = videoHeight;

      // ✅ Draw video exactly (no resize, no squeeze)
      context.drawImage(video, 0, 0, videoWidth, videoHeight);
      contextSend.drawImage(video, 0, 0, videoWidth, videoHeight);

      // context.drawImage(
      //   video,
      //   // sourceX,
      //   // sourceY,
      //   // captureSize,
      //   // captureSize,
      //   0,
      //   0,
      //   canvas.width,
      //   canvas.height
      // );

      // contextSend.drawImage(video, 0, 0, canvasSend.width, canvasSend.height);

      const imageDataURL = canvas.toDataURL("image/jpeg", 0.5);

      localStorage.setItem("image", imageDataURL);

      const imageDataURLSend = canvasSend.toDataURL("image/jpeg", 0.5);

      localStorage.setItem("imageDataURLSend", imageDataURLSend);

      const userDocData = JSON.parse(
        localStorage.getItem(`userPayload_${visitorId}`)
      );

      axios({
        url: "/event/verify/find-face",
        method: "POST",
        data: {
          img_base64: imageDataURLSend.replace(
            /^data:image\/[a-z]+;base64,/,
            ""
          ),
          liveliness_check: liveness,
        },
        disableError: true,
        disableRedirect: true,
      }).then((response) => {
        if (!response.status) {
          setLoading(false);
          setUserStatus(true);
          !response.data.message
            ? setUserData(response.data)
            : setUserData({ message: response.displayMessage });
        } else {
          setLoading(false);
          if (userDocData?.doc_face_image && doc_face == false) {
            axios({
              url: "event/verify/face",
              method: "POST",
              data: {
                doc_face_image: userDocData?.doc_face_image,
                captured_face_image: imageDataURLSend.replace(
                  /^data:image\/[a-z]+;base64,/,
                  ""
                ),
              },
            }).then((response) => {
              if (response.status) {
                navigate(
                  pages.previewVideo.route +
                    `?visitor_id=${
                      visitor_id || visitorId || visitor_ID || ""
                    }&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&doc_face=${doc_face}${
                      popup ? "&popup=" + popup : ""
                    }&auto_consent=${autoConsent}${
                      indepentent ? "&indepentent=" + indepentent : ""
                    }`,

                  {
                    state: {
                      blob: imageDataURL || "",
                      blob2: imageDataURLSend || "",

                      matchPercentage: response.data?.match_percentage || "",
                      appointmentData: location.state?.appointmentData || "",
                      clickPhotoURL: location.pathname + location.search,
                      // type: type || "",
                      popup: popup || "",
                    },
                    replace: false,
                  }
                );
                stopCamera();
              }
            });
          } else {
            navigate(
              pages.previewVideo.route +
                `?visitor_id=${
                  visitor_id || visitorId || visitor_ID || ""
                }&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&doc_face=${doc_face}${
                  popup ? "&popup=" + popup : ""
                }&auto_consent=${autoConsent}${
                  indepentent ? "&indepentent=" + indepentent : ""
                }`,
              {
                state: {
                  blob: imageDataURL || "",
                  blob2: imageDataURLSend || "",
                  matchPercentage:
                    imageDataURL.replace(/^data:image\/[a-z]+;base64,/, "") ||
                    "",
                  appointmentData: location.state?.appointmentData || "",

                  // type: type || "",
                  clickPhotoURL: location.pathname + location.search,
                  popup: popup || "",

                  docFace: doc_face || "",
                },
                replace: false,
              }
            );
            stopCamera();
          }
        }
      });
    }
    // }
  };

  useEffect(() => {
    if (fromPreview == "true") {
      // Check if device is iPhone or iPad
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

      if (isIOS) {
        setCameraStartPopUp(true);
        // Wait for user tap before starting camera
        const enableCamera = () => {
          startCamera();
          setStartRecording(true);
          setCameraStartPopUp(false);
          document.removeEventListener("touchstart", enableCamera);
          document.removeEventListener("click", enableCamera);
        };

        document.addEventListener("touchstart", enableCamera, { once: true });
        document.addEventListener("click", enableCamera, { once: true });
      } else {
        startCamera();
        setStartRecording(true);
      }
    }
  }, []);

  useEffect(() => {
    loader.start();
    axios({
      url: "event/visitor/get-visitor",
      method: "POST",
      data: { encrypted_face_data: getVisitorFaceData(visitorId) },
    }).then((response) => {
      if (response.status) {
        if (response.data.is_doc_verified) {
          setUserStatusPopup(true);
        }
      }
      loader.apiComplete();
    });
  }, []);

  return (
    <Loader>
      <Fragment>
        {!startRecording && (
          <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
              <OuterBox2>
                <OuterPaper sx={{ p: 0 }} elevation={3}>
                  <Box
                    sx={{
                      width: "100%",
                      position: "relative",
                      height: { xs: "200px", sm: "280px", md: "35vh" },
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sx={{
                        position: "relative",
                        zIndex: 2,
                        top: "50%",
                        left: "2%",
                        transform: "translateY(-50%)",
                        pt: 10,
                      }}
                    >
                      <Typography
                        variant="h5"
                        fontWeight={900}
                        sx={{
                          marginTop: "7.5px",
                          fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2rem" },
                        }}
                      >
                        Identity Verification
                        <Tooltip title="Instruction">
                          <IoIosInformationCircleOutline
                            style={{
                              verticalAlign: "middle",
                              color: "#AAA9F3",
                              marginLeft: "6px",
                            }}
                            onClick={() => setOpen(true)}
                          />
                        </Tooltip>
                      </Typography>
                      <Typography
                        variant="body2"
                        fontWeight={500}
                        sx={{
                          marginTop: "7.5px",
                          color: "#00000099",
                          pr: { xs: 2, sm: 4 },
                        }}
                      >
                        Please complete the following steps to verify your
                        identity <strong>{entityDetails.campus_name}</strong>.
                      </Typography>
                    </Grid>
                    <img
                      style={{
                        height: "100%",
                        position: "absolute",
                        top: 0,
                        // left: 0,
                        maxWidth: "50%",
                        objectFit: "contain",
                      }}
                      src={FaceVerification}
                    />
                  </Box>
                </OuterPaper>
              </OuterBox2>
            </Grid>
          </Grid>
        )}

        <form style={{ ...(startRecording && { height: "100%" }) }}>
          {!startRecording ? (
            <Grid container justifyContent="center">
              <Grid item xs={12} md={10} lg={8}>
                <OuterBox2>
                  <OuterPaper sx={{ p: { xs: 4, sm: 5, md: 6 } }} elevation={3}>
                    <Fragment>
                      <Grid
                        container
                        sx={{
                          alignItems: "center",
                          justifyContent: "space-evenly",
                          mb: 4,
                        }}
                      >
                        <Divider
                          sx={{ background: "#0000001A", width: "20%" }}
                        />
                        <Typography
                          variant="h6"
                          fontWeight={500}
                          sx={{
                            textAlign: "center",
                            color: "#00000080",
                            mx: 1,
                          }}
                        >
                          Steps
                        </Typography>
                        <Divider
                          sx={{ background: "#0000001A", width: "20%" }}
                        />
                      </Grid>

                      {/* Selfie Requirements */}
                      <Grid container spacing={2}>
                        {[
                          {
                            title: "Face ID Verification",
                            description:
                              "Capture a selfie for facial recognition. Enable camera, mic & location, keep your face in frame with good lighting, and use live video.",
                          },
                          {
                            title: "Choose a Verification Document",
                            // description: "Select one of the following:",
                            subItems: [
                              "Aadhaar",
                              "Driving License",
                              "Passport",
                            ],
                          },
                          {
                            title: "Identity Matching",
                            description:
                              "We will match your name and Face ID with your selected government-issued document.",
                          },
                          {
                            title: "Consent & Privacy Declaration",
                            description:
                              "Review and accept the privacy policy and terms of consent.",
                          },
                          {
                            title: "Confirmation",
                            description:
                              "Receive confirmation upon successful verification.",
                          },
                        ].map((item, idx) => (
                          <Grid item xs={12} sm={6} key={idx}>
                            <Card
                              variant="outlined"
                              sx={{
                                height: "100%",
                                borderColor: "white",
                                boxShadow: "none !important",
                              }}
                            >
                              <CardContent
                                sx={{
                                  p: { xs: 0, sm: 0 },
                                  "&:last-child": { pb: 0 },
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    // mb: 1,
                                  }}
                                >
                                  <Typography
                                    variant="body1"
                                    fontWeight={500}
                                    sx={{ minWidth: "24px" }}
                                  >
                                    {`${idx + 1}.`}
                                  </Typography>
                                  <Box sx={{ ml: 1 }}>
                                    <Typography
                                      variant="body1"
                                      fontWeight={800}
                                    >
                                      {item.title}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ mt: 0.5 }}
                                    >
                                      {item.description}
                                    </Typography>
                                    {item.subItems && (
                                      <ul
                                        style={{
                                          margin: "4px 0 0 16px",
                                          padding: 0,
                                        }}
                                      >
                                        {item.subItems.map(
                                          (subItem, subIdx) => (
                                            <li key={subIdx}>
                                              <Typography
                                                variant="body2"
                                                color="text.secondary"
                                              >
                                                {subItem}
                                              </Typography>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    )}
                                  </Box>
                                </Box>
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    </Fragment>

                    <LoadingButton
                      onClick={() => {
                        startCamera();
                        setStartRecording(true);
                        setCameraStartPopUp(false);
                      }}
                      fullWidth
                      style={{ marginTop: "15px", py: 1.5, boxShadow: "none" }}
                    >
                      Start Verification
                    </LoadingButton>
                  </OuterPaper>
                </OuterBox2>
              </Grid>
            </Grid>
          ) : (
            <React.Fragment>
              <Grid item container height={"100%"}>
                <Grid item container justifyContent={"center"}>
                  <Grid
                    item
                    container
                    md={12}
                    sl={6}
                    sx={{
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    {" "}
                    <OuterBox2>
                      <OuterPaper2 elevation={3}>
                        <video
                          id="video"
                          width="100%"
                          // height="100%"
                          style={{
                            objectFit: "fill",
                            borderRadius: "0px !important",
                            transform: "scaleX(-1)",
                            height: "90vh",
                          }}
                          ref={videoRef}
                          muted
                          autoPlay
                          playsInline
                        ></video>

                        <canvas
                          ref={canvasRef}
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "90vh",
                            transform: "scaleX(-1)",
                            zIndex: 10,
                            pointerEvents: "none",
                          }}
                        ></canvas>

                        <Grid
                          item
                          xs={12}
                          display={"flex"}
                          justifyContent={"center"}
                          style={{
                            position: "absolute",
                            // bottom: "70px",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            top: "8vh",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 450 350"
                            fill="none"
                            style={{
                              width: "100%",
                              height: "auto",
                              maxWidth: "390px",
                              display: "block",
                              marginTop: "55px",
                            }}
                          >
                            {/* Base dotted oval */}
                            <ellipse
                              cx="220"
                              cy="170"
                              rx="110" // bigger horizontal radius
                              ry="170" // bigger vertical radius
                              stroke={disableButton ? "red" : "#15ff15"}
                              strokeOpacity="1"
                              strokeWidth="2"
                              strokeDasharray="7.5 7.5"
                            />
                          </svg>

                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 361 361"
                            fill="none"
                            style={{
                              width: "100%",
                              height: "auto",
                              maxWidth: "270px",
                              display: "block",
                              marginTop: "55px",
                            }}
                          >
                            <circle
                              cx="180.5"
                              cy="180.5"
                              r="180"
                              stroke={disableButton ? "red" : "green"}
                              stroke-opacity="2.9395"
                              strokeWidth="5"
                              strokeDasharray="7.5 7.5"
                            />
                          </svg> */}

                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="50"
                            height="60"
                            viewBox="0 0 28 28"
                            fill="none"
                          >
                            <path
                              d="M2 8.88254V8.70607C2 5.00252 5.00232 2.0002 8.70587 2.0002V2.0002"
                              stroke="white"
                              stroke-width="1.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M2 19.1179V19.2943C2 22.9979 5.00232 26.0002 8.70587 26.0002V26.0002"
                              stroke="white"
                              stroke-width="1.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M25.8232 8.88254V8.70607C25.8232 5.00252 22.8209 2.0002 19.1174 2.0002V2.0002"
                              stroke="white"
                              stroke-width="1.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M25.8232 19.1179V19.2943C25.8232 22.9979 22.8209 26.0002 19.1174 26.0002V26.0002"
                              stroke="white"
                              stroke-width="1.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M18.8806 19.0522V19.0522C16.3528 20.1757 13.4673 20.1757 10.9395 19.0522V19.0522"
                              stroke="#3936EF"
                              stroke-opacity="0.4"
                              stroke-width="1.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M15.435 10.2287V14.0164C15.435 15.0128 14.7379 15.8733 13.7632 16.0801V16.0801"
                              stroke="#3936EF"
                              stroke-opacity="0.4"
                              stroke-width="2.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M9.88086 10.2287L9.88086 12.3185"
                              stroke="#3936EF"
                              stroke-opacity="0.4"
                              stroke-width="2.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M20.1162 10.2287L20.1162 12.3185"
                              stroke="#3936EF"
                              stroke-opacity="0.4"
                              stroke-width="2.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M17.8816 19.0526V19.0526C15.3537 20.1761 12.4683 20.1761 9.94043 19.0526V19.0526"
                              stroke="white"
                              stroke-width="2.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M14.436 10.2291V14.0168C14.436 15.0132 13.7389 15.8737 12.7642 16.0805V16.0805"
                              stroke="white"
                              stroke-width="2.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M8.88184 10.2291L8.88184 12.3189"
                              stroke="white"
                              stroke-width="2.4"
                              stroke-linecap="round"
                            />
                            <path
                              d="M19.1172 10.2291L19.1172 12.3189"
                              stroke="white"
                              stroke-width="2.4"
                              stroke-linecap="round"
                            />
                          </svg>
                          <Typography
                            variant="h5"
                            style={{
                              fontWeight: "900",
                              color: "white",
                              margin: "5px 0px",
                            }}
                          >
                            Face Verification Initiated...
                          </Typography>
                          <Typography
                            variant="body1"
                            style={{
                              fontWeight: "900",
                              color: "white",
                              margin: "5px 0px",
                            }}
                          >
                            Please verify the image before submitting
                          </Typography>

                          <LoadingButton
                            id="click-photo"
                            type="button"
                            onClick={takePhoto}
                            loading={loading}
                            style={{
                              padding: "10px 45px",
                              width: "95%",
                              boxShadow: "none",
                              marginTop: buttonMargin,
                            }}
                            disabled={disableButton}
                          >
                            Click Photo
                          </LoadingButton>
                        </Grid>

                        {/* <canvas
                          id="canvas"
                          width="480"
                          height="600"
                          ref={canvasRef}
                          style={{ display: "none" }}
                        ></canvas> */}
                        <canvas
                          id="canvasSendRef"
                          width="600"
                          height="600"
                          ref={canvasSendRef}
                          style={{ display: "none" }}
                        ></canvas>
                      </OuterPaper2>
                    </OuterBox2>
                  </Grid>
                </Grid>
              </Grid>
            </React.Fragment>
          )}
        </form>

        <Instruction open={open} setOpen={setOpen} />

        {/* <CameraStartPopUp
        startCamera={startCamera}
        cameraStartPopUp={cameraStartPopUp}
        setStartRecording={setStartRecording}
        setCameraStartPopUp={setCameraStartPopUp}
      /> */}

        <Error
          open={errorOpen}
          setOpen={setErrorOpen}
          ErrorMessage={error}
          CloseButton={false}
        />

        <UserStatus
          userStatus={userStatus}
          setUserStatus={setUserStatus}
          setUserData={setUserData}
          userData={userData}
        />

        <UserStatusPopup
          // userData={userData?.userData[0]}
          setUserData={setUserData}
          userStatus={UserStatusPop}
          setUserStatus={setUserStatusPopup}
        />

        {cameraStartPopUp && (
          <Box
            onClick={() => setCameraStartPopUp(false)}
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              color: "white",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              textAlign: "center",
              p: 2,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
              Tap anywhere to enable your camera
            </Typography>
            <Typography variant="body2">
              Safari requires a tap to re-enable camera access for privacy
              reasons.
            </Typography>
          </Box>
        )}

        {/* {disableButton && (
          <div
            style={{
              position: "absolute",
              top: "12.5%",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "rgba(255, 0, 0, 0.8)",
              color: "white",
              padding: "10px 20px",
              borderRadius: "10px",
              fontWeight: "bold",
              zIndex: 9999,
              textAlign: "center",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
              animation: "fadeIn 0.3s ease",
            }}
          >
            {guideMessage}
          </div>
        )} */}
      </Fragment>
    </Loader>
  );
}
